export const DocumentAtvCrReceptionStatusLabelComponent = {
  template: `<span class="status-label text-{{ vm.statusClass }}"><i class="fa fa-circle"></i> {{ vm.statusTitle }}</span>`,
  bindings: {
    status: '<',
  },
  controller: DocumentAtvCrReceptionStatusLabelController,
  controllerAs: 'vm',
};

DocumentAtvCrReceptionStatusLabelController.$inject = ['$translate'];

function DocumentAtvCrReceptionStatusLabelController($translate) {
  const vm = this;

  vm.$onChanges = function () {
    setStatusLabel();
  };

  function setStatusLabel() {
    let statusClass = '';
    let statusIcon = '';
    let statusTitle = '-';

    switch (vm.status) {
      case 'accepted':
        statusClass = 'success';
        statusIcon = 'check-square';
        statusTitle = 'ACCEPTED';
        break;
      case 'accepted_partially':
        statusClass = 'warning';
        statusIcon = 'check-square-o';
        statusTitle = 'PARTIALLY_ACCEPTED';
        break;
      case 'rejected':
        statusClass = 'danger';
        statusIcon = 'ban';
        statusTitle = 'REJECTED';
        break;
      default:
        statusClass = 'primary';
        statusIcon = 'spinner';
        statusTitle = 'PENDING';
        break;
    }

    vm.statusClass = statusClass;
    vm.statusIcon = statusIcon;
    vm.statusTitle = $translate.instant(statusTitle);
  }
}
